import * as dialogs from "./dialogs";
import { ActionLog } from "./lib/actionLog";
import * as browserStorage from "./lib/browserStorage";
import * as charts from "./lib/charts";
import { DialogHistory } from "./lib/dialogHistory";
import * as flatpickr from "./lib/flatpickr";
import * as listview from "./lib/listView";
import * as mainMenu from "./lib/mainMenu";
import { Notifications } from "./lib/notifications";
import * as popups from "./lib/popups";
import { ProcedureShortcuts } from "./lib/procedureShortcuts";
import { session, setSessionValues } from "./lib/pyratSession";
import type { initSentry } from "./lib/sentry";
import * as sites from "./sites";

export const notifications = new Notifications();
export const actionLog = new ActionLog();
export const dialogHistory = new DialogHistory();
export { mainMenu };

export const pyratFrontend = {
    // Session value access
    session,
    setSessionValues,
    initSentry: async (...args: Parameters<typeof initSentry>) => {
        const { initSentry } = await import("./lib/sentry");
        return await initSentry(...args);
    },

    // Functions
    actionLog,
    browserStorage,
    charts,
    dialogs,
    flatpickr,
    notifications,
    listview,
    popups,
    sites,
    mainMenu,

    // classes
    ProcedureShortcuts,
};
